import { Builder, Field, From, inc, Schema } from '@bonusly/schema';

@Schema()
export class User {
	@Field()
	@From('id')
	public id = '';

	@Field()
	@From('displayName')
	public displayName = '';

	@Field()
	@From('email')
	public email = '';

	@Field()
	@From('profilePic')
	public profilePic = '';

	@Field()
	@From('username')
	public username = '';

	public get userTag() {
		return `@${this.username}`;
	}
}

export const UserBuilder = new Builder(User, {
	id: inc(String),
	displayName: 'Test User',
	email: 'user@example.com',
	profilePic: 'http://www.example.com/image.jpg',
	username: 'test.user',
});
